import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export default function PageLoadAnimation() {
  const location = useLocation();
  const isActive = useSelector((state) => state.toggle.isActive);

  useEffect(() => {
    const bars = document.getElementById('bars');

    if (bars) {
      // Use requestAnimationFrame for smoother animations
      const showAnimation = () => {
        if (isActive) {
          bars.classList.remove('hide_ar');
          bars.classList.remove('show');
          bars.classList.add('show_ar');
          bars.classList.remove('hide');
        } else {
          bars.classList.add('show');
          bars.classList.remove('show_ar');
          bars.classList.remove('hide');
          bars.classList.remove('hide_ar');
        }
      };

      const hideAnimation = () => {
        if (isActive) {
          bars.classList.remove('show_ar');
          bars.classList.remove('hide');
          bars.classList.add('hide_ar');
        } else {
          bars.classList.remove('show');
          bars.classList.remove('hide_ar');
          bars.classList.add('hide');
        }
      };

      requestAnimationFrame(() => {
        showAnimation();
        setTimeout(() => {
          requestAnimationFrame(hideAnimation);
        }, 800); // 800ms or your preferred duration
      });
    }
  }, [isActive, location]);

  return (
    <div id="bars" className="bars">
      <div />
      <div style={{ animationDelay: '0.1s' }} />
    </div>
  );
}
